// extracted by mini-css-extract-plugin
export default {"spinner":"inward_spinner__UMxcL","spin":"inward_spin__GO6yJ"};